import { Row, Col } from "antd";

import CustomTitle from "../../../app/generic/customTitle";

const Summary = ({ sent, insolvency }) => (
  <Row justify="center">
    <Col>
      <CustomTitle
        level={5}
        id={
          sent
            ? insolvency
              ? "registration.sent.insolvency"
              : "registration.sent.info"
            : "registration.summary.title"
        }
        defaultMessage={
          sent
            ? insolvency
              ? "Pro dokončení registrace prosím Zákaznický servis DHL Freight CZ na telefonním čísle 239 018 222 nebo napište email na DHLFreight.CZ@dhl.com."
              : "Registrace byla již odeslána do DHL, tudíž ji není možné editovat."
            : "Registrace je skoro u konce, nyní potvrďte odeslání registrace do DHL kliknutím na tlačítko níže a očekávejte email s dalšími informacemi."
        }
      />
    </Col>
  </Row>
);

export default Summary;
